"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var style_1 = __importStar(require("./style"));
var transifex_1 = require("../../transifex");
var StyledAntdModal = styled_components_1.default(antd_1.Modal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), style_1.default);
var Modal = function (_a) {
    var children = _a.children, visible = _a.visible, onClose = _a.onClose, _b = _a.disableSubmitButton, disableSubmitButton = _b === void 0 ? false : _b, _c = _a.onSubmit, onSubmit = _c === void 0 ? function () { return null; } : _c, variant = _a.variant, loading = _a.loading, fullscreen = _a.fullscreen, width = _a.width, styles = _a.styles, restProps = __rest(_a, ["children", "visible", "onClose", "disableSubmitButton", "onSubmit", "variant", "loading", "fullscreen", "width", "styles"]);
    var txLoading = transifex_1.useTxStrings().txLoading;
    return (react_1.default.createElement(StyledAntdModal, __assign({ "$styles": styles, "$isFullScreen": fullscreen, "$isWithFooter": !!restProps.footer, style: fullscreen
            ? {
                top: "0%",
                left: "0%",
                maxWidth: "100%",
                padding: 0,
            }
            : {}, "$variant": variant, visible: visible, onCancel: onClose, onOk: onSubmit, okButtonProps: { disabled: disableSubmitButton }, width: fullscreen ? "100%" : width }, restProps), loading ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(style_1.ModalLoadContainer, null,
            react_1.default.createElement(antd_1.Space, { size: "middle" },
                react_1.default.createElement(antd_1.Spin, { size: "large", tip: txLoading }))))) : (children)));
};
exports.default = Modal;
var templateObject_1;
